"use client";

import React, { useState, useEffect } from "react";
import { ShieldCheck, Terminal, Cpu, Network, Lock, ChevronRight, ChevronLeft, ArrowRight } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const consultants = [{
  name: "Arthur Vance",
  role: "Managing Principal",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1619657/img/consultant_bw_1.png",
  certs: ["MBA", "PMP", "ITIL Master"],
  bio: "Specializing in high-level technical oversight and the optimization of enterprise-scale digital workflows."
}, {
  name: "Sarah Chen",
  role: "Director of Digital Strategy",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1619657/img/consultant_bw_2.png",
  certs: ["Lean Six Sigma", "CSM", "TOGAF"],
  bio: "Expert in bridging organizational efficiency with modern technological infrastructures for Fortune 500 firms."
}, {
  name: "Marcus Thorne",
  role: "Infrastructure Architect",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1619657/img/consultant_bw_3.png",
  certs: ["CCIE", "Azure Solutions", "VCP"],
  bio: "Designing resilient internal infrastructures that serve as the foundation for professional service delivery."
}, {
  name: "Elena Rostova",
  role: "Operations Lead",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1619657/img/consultant_bw_4.png",
  certs: ["COBIT 5", "CISM", "Six Sigma"],
  bio: "Focused on streamlining operational workflows through the precise application of architectural logic."
}, {
  name: "David Miller",
  role: "Senior Advisory Consultant",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1619657/img/consultant_bw_5.png",
  certs: ["CISA", "CRISC", "CISSP"],
  bio: "Providing strategic business advisory to navigate complex technological landscapes and mitigate risk."
}];
export default function EngineeredForExcellence() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    setMounted(true);
  }, []);
  return <section data-section-id="59309" id="our-advisory-ethos" ref={ref} className="dark bg-background text-foreground relative overflow-hidden py-24 sm:py-32">
      {}
      <div className="absolute inset-0 z-0 pointer-events-none">
        {}
        <div className="absolute inset-0 bg-[linear-gradient(to_right,var(--color-border)_1px,transparent_1px),linear-gradient(to_bottom,var(--color-border)_1px,transparent_1px)] bg-[size:40px_40px] opacity-[0.05]"></div>
        
        {}
        <div className="absolute inset-0 bg-[linear-gradient(to_bottom,transparent_50%,rgba(0,0,0,0.4)_50%)] bg-[size:100%_4px] opacity-20 pointer-events-none"></div>
        
        {}
        <div className="absolute top-0 left-1/4 w-96 h-96 bg-primary/15 rounded-full blur-[128px] -translate-y-1/2"></div>
        <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-accent/10 rounded-full blur-[128px] translate-y-1/2"></div>
      </div>

      <div className="container relative z-10 mx-auto px-4 sm:px-6 lg:px-8">
        {}
        <div className={`max-w-4xl mx-auto text-center mb-20 transition-all duration-1000 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary/10 border border-primary/30 text-primary text-xs font-mono tracking-widest uppercase mb-6">
            <span className="relative flex h-2 w-2">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-primary opacity-75"></span>
              <span className="relative inline-flex rounded-full h-2 w-2 bg-primary"></span>
            </span>
            Status: Strategic Alignment
          </div>
          
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight mb-8 text-white font-sans">
            Merging Logic with <span className="text-primary">Vision</span>
          </h2>
          
          <p className="text-xl md:text-2xl text-muted-foreground font-sans leading-relaxed max-w-3xl mx-auto">
            At Century Pointe Holdings, we don't just advise; we optimize. Our mission is to provide technical oversight that transforms internal infrastructures into high-performance engines. By fusing architectural precision with strategic business advisory, we empower organizations to navigate the intersection of modern technology and operational efficiency with absolute clarity.
          </p>
        </div>

        {}
        

        {}
        <div className={`mt-16 text-center transition-all duration-1000 delay-500 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          <Link to="/OptimizationStrategyPage">
            <Button size="lg" className="group bg-primary text-primary-foreground hover:bg-primary/90 shadow-[0_0_25px_-5px_rgba(0,242,255,0.4)] border-none rounded-none font-sans font-bold uppercase tracking-wider px-8">
              Explore Our Strategy
              <ArrowRight className="ml-2 h-4 w-4 transition-transform group-hover:translate-x-1" />
            </Button>
          </Link>
        </div>
      </div>
    </section>;
}